var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ClientCheck"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$props.title))]),_c('div',{staticClass:"icon"},[(_vm.$props.value)?_c('div',{staticClass:"check active",on:{"click":function($event){return _vm.onChange(false)}}}):_c('div',{staticClass:"check",on:{"click":function($event){return _vm.onChange(true)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }